module.exports = __webpack_public_path__ + "img/Rhonda_Morris@2x.4964814b.png";